import { BlockedPremiumFeatureModal } from './BlockedPremiumFeatureModal';

export default BlockedPremiumFeatureModal;
